import React from "react";
import ReactDOM, { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import NotificationPanel from "./components/NotificationPanel";
import MessageApp from "./components/MessageApp";

const renderNotification = () => {
  const target = document.querySelector('[app36-element="notification"]');
  if (target) {
    const root = createRoot(target);
    root.render(<NotificationPanel />);
  }
};

window.addEventListener("message", (event: MessageEvent) => {
  if (event.data.messageType === "RENDER_NOTIFICATION") {
    renderNotification();
  }
});

window.addEventListener("message", (event: MessageEvent) => {
  if (event.data.messageType === "RENDER_MESSAGES_APP") {
    const target = document.querySelector('[app36-element="messaging-app"]');
    if (target) {
      const root = createRoot(target);
      root.render(<MessageApp userData={event.data.payload} />);
    }
  }
});

document.addEventListener("readystatechange", (event: any) => {
  if (document.readyState === "interactive") {
    const container = document.body.appendChild(document.createElement("div"));
    const root = ReactDOM.createRoot(container);
    root.render(<App />);
  }
});
